import Color from 'color';

const BLACK = '#333333';
const WHITE = 'white';
const DARK_BLUE = '#151935';
const LIGHTER_DARK_BLUE = '#1b2342';
const LIGHTER_DARK_BLUE_02 = '#1e234a';
const LIGHT_BLUE = '#1a92ec';
const LIGHTER_BLUE = '#2b9ef5';
const LIGHT_BLUE_02 = '#eef7fe';
const PURPLE = '#5668ff';
const GRAY = '#bbbbbb';
const GREEN = '#36d123';
const HOVER_LIST = '#2B9EF5';
const RED_PURPLE = '#af09f1';

const constants = {
  BASE_FONT_SIZE: 14,
  BASE_FONT_FAMILY: `'Montserrat', sans-serif`,
  BASE_FONT_COLOR: BLACK,
  WHITE: WHITE,

  // Header
  HEADER_BG_COLOR: LIGHTER_BLUE,
  HEADER_FONT_COLOR: WHITE,
  HEADER_ADMIN_BG_COLOR: '#222848',

  // Login
  LOGIN_BG_COLOR: '#151935',
  LOGIN_FORM_BG_COLOR: LIGHTER_DARK_BLUE,
  LOGIN_HIGHLIGHT_COLOR: PURPLE,
  LOGIN_BUTTON_BG_COLOR: PURPLE,
  LOGIN_BUTTON_TEXT_COLOR: WHITE,
  LOGIN_TEXT_COLOR: WHITE,
  LOGIN_INPUT_COLOR: GRAY,

  // Admin
  ADMIN_BG_COLOR: DARK_BLUE,
  ADMIN_TEXT_COLOR: WHITE,

  // Accordion
  ACCORDION_PARENT_BG_COLOR: '#222848',
  ACCORDION_PARENT_HOVER_BG_COLOR: Color('#222848')
    .darken(0.2)
    .toString(),
  ACCORDION_CHILD_BG_COLOR: '#13162d',
  ACCORDION_CHILD_HOVER_BG_COLOR: Color('#13162d')
    .darken(0.3)
    .toString(),
  ACCORDION_PARENT_LABEL_COLOR: Color('#bfbfbf')
    .fade(0.6)
    .toString(),
  ACCORDION_PARENT_VALUE_COLOR: '#f2f2f2',
  ACCORDION_ZONE_TEXT_COLOR: LIGHT_BLUE,
  ACCORDION_LOCATION_TEXT_COLOR: GRAY,
  ACCORDION_BORDER_COLOR: Color(WHITE)
    .fade(0.8)
    .toString(),
  //User
  USER_PARENT_BG_COLOR: '#222848',
  USER_PARENT_HOVER_BG_COLOR: Color('#222848')
    .darken(0.2)
    .toString(),
  USER_CHILD_BG_COLOR: '#13162d',
  USER_CHILD_HOVER_BG_COLOR: Color('#13162d')
    .darken(0.3)
    .toString(),
  USER_PARENT_LABEL_COLOR: Color('#bfbfbf')
    .fade(0.6)
    .toString(),
  USER_PARENT_VALUE_COLOR: '#f2f2f2',
  USER_ZONE_TEXT_COLOR: LIGHT_BLUE,
  USER_LOCATION_TEXT_COLOR: GRAY,
  USER_BORDER_COLOR: Color(WHITE)
    .fade(0.8)
    .toString(),
  // Table
  TABLE_BG_COLOR: DARK_BLUE,
  TABLE_DATA_BG_COLOR: LIGHTER_DARK_BLUE,
  TABLE_DATA_BORDER_COLOR: '#2e9bff22',
  TABLE_HEADER_TEXT_COLOR: LIGHT_BLUE,
  TABLE_TEXT_COLOR: WHITE,
  TABLE_SELECTED_COLOR: PURPLE,
  PAGINATOR_BG_COLOR: LIGHTER_DARK_BLUE_02,
  FILTER_BG_COLOR: PURPLE,
  FILTER_TAG_COLOR: WHITE,
  FILTER_TEXT_COLOR: PURPLE,

  // Workflows Table
  WORKFLOWS_HEADER_BG_COLOR: LIGHT_BLUE_02,
  WORKFLOWS_BORDER_COLOR: Color(LIGHT_BLUE_02)
    .darken(0.03)
    .toString(),

  // Modal
  MODAL_BACKGROUND_COLOR: WHITE,
  MODAL_TEXT_COLOR: DARK_BLUE,
  MODAL_TITLE_BACKGROUND_COLOR: LIGHT_BLUE,
  MODAL_TITLE_TEXT_COLOR: WHITE,

  // Modal Tabs
  MODALTABS_NAV_BACKGROUND_COLOR: LIGHT_BLUE,
  MODALTABS_TAB_COLOR: WHITE,

  // Icon
  ICON_DEFAULT_COLOR: WHITE,
  ICON_DEFAULT_SIZE: 16,
  ICON_SELECTED: LIGHTER_BLUE,

  // Button
  BUTTON_BG_COLOR: LIGHTER_BLUE,
  BUTTON_DARK_BG_COLOR: DARK_BLUE,
  BUTTON_HOVER_BG_COLOR: LIGHT_BLUE,
  BUTTON_WHITE_HOVER_BG_COLOR: Color(WHITE)
    .fade(0.95)
    .toString(),
  BUTTON_DARK_HOVER_BG_COLOR: LIGHTER_DARK_BLUE,
  BUTTON_COLOR: WHITE,

  // Flat Button
  FLAT_BUTTON_BG_COLOR: WHITE,
  FLAT_BUTTON_COLOR: LIGHT_BLUE,

  // Select
  SELECT_BG_COLOR: WHITE,
  SELECT_BORDER_COLOR: LIGHTER_BLUE,
  SELECT_ITEM_BG_COLOR: WHITE,
  SELECT_ITEM_HOVER: LIGHTER_BLUE,
  SELECT_ITEM_TEXT_COLOR: BLACK,
  SELECT_ITEM_TEXT_SELECTED_COLOR: WHITE,
  SELECT_ITEM_BORDER_COLOR: `${GRAY}99`,
  //Dropdown
  DROP_BG_COLOR: DARK_BLUE,
  DROP_BORDER_COLOR: LIGHTER_BLUE,
  DROP_ITEM_BG_COLOR: WHITE,
  DROP_ITEM_HOVER: HOVER_LIST,
  DROP_ITEM_TEXT_COLOR: BLACK,
  DROP_ITEM_TEXT_SELECTED_COLOR: WHITE,
  DROP_ITEM_BORDER_COLOR: `${GRAY}99`,
  // Multiselect
  MULTISELECT_FILTER_BORDER_COLOR: `${GRAY}70`,

  // File upload
  FILE_UPLOAD_COLOR: Color('#272727')
    .fade(0.6)
    .toString(),
  FILE_UPLOAD_ICON_COLOR: '#eaeaea',

  // Mapbox
  MAP_POINT_COLOR: PURPLE,
  MAP_POINT_GPS_COLOR: PURPLE,
  MAP_POINT_WIFI_COLOR: RED_PURPLE,
  MAP_POINT_CELLID_COLOR: GREEN,
  MAP_POINT_GPS_TRANSPARENT_COLOR: Color(PURPLE)
    .fade(0.7)
    .toString(),
  MAP_POINT_WIFI_TRANSPARENT_COLOR: Color(RED_PURPLE)
    .fade(0.7)
    .toString(),
  MAP_POINT_CELLID_TRANSPARENT_COLOR: Color(GREEN)
    .fade(0.7)
    .toString(),
  MAP_POINT_BORDER: Color(PURPLE)
    .fade(0.7)
    .toString(),
  MAP_POINT_SELECTED_BORDER: Color(PURPLE)
    .fade(0.5)
    .toString(),
  MAP_POLYGON_LINE_COLOR: '#eb4986',
  MAP_POLYGON_LINE_CIRCLE_COLOR: WHITE,
  MAP_AREA_POLYGON_LINE_COLOR: PURPLE,
  MAP_AREA_POLYGON_LINE_CIRCLE_COLOR: WHITE,
  MAP_TEXT_COLOR: WHITE,
  MAP_PATH_COLOR: '#000000', // must be hex
  // Common
  HIGHLIGHT_COLOR: LIGHTER_BLUE,

  PLACEHOLDER_COLOR: GRAY,
  DISABLED_COLOR: '#545454',
  DISABLED_BG_COLOR: '#ebebe4',
  DISABLED_STATUS_COLOR: Color('#ebebe4')
    .darken(0.2)
    .toString(),
  DANGER_STATUS_COLOR: '#f75e5e',
  WARNING_STATUS_COLOR: '#f7ce5e',
  SUCCESS_STATUS_COLOR: '#78e08b',
  ERROR_BACKGROUND_COLOR: '#ffecee',
  ERROR_BORDER_COLOR: '#ffd1dc',
  ERROR_TEXT_COLOR: DARK_BLUE,
  SUCCESS_STATUS_COLOR_HOVER: Color('#78e08b')
    .darken(0.3)
    .toString(),
  DANGER_STATUS_COLOR_HOVER: Color('#f75e5e')
    .darken(0.3)
    .toString(),
  DANGER_ERROR_COLOR: 'rgb(255, 0, 0)',
  ERROR_BACKGROUND_COLOR_DANGER: '#fff',

  //status
  STATUS_PARENT_BG_COLOR: '#222848',
  STATUS_PARENT_HOVER_BG_COLOR: Color('#222848')
    .darken(0.2)
    .toString(),
  STATUS_PARENT_LABEL_COLOR: Color('#bfbfbf')
    .fade(0.6)
    .toString(),
  STATUS_PARENT_VALUE_COLOR: '#f2f2f2',
  STATUS_CHILD_BG_COLOR: '#13162d',
  STATUS_CHILD_HOVER_BG_COLOR: Color('#13162d')
    .darken(0.3)
    .toString(),
  STATUS_PARENT_VALUE_COLOR_HEADER: 'grey',
  STATUS_RED_COLOR: '#f75e5e',
  STATUS_GREEN_COLOR: 'rgb(120, 224, 139)',
  STATUS_YELLOW_COLOR: 'rgb(247, 206, 94)',
  RESIZE_HANDLER_COLOR: DARK_BLUE,
  NO_SITES_FOUND_LINK: LIGHTER_BLUE,
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants/styles.js